import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import "../assets/css/booktablepage.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const BookTablePage = () => {
    const { pkid } = useParams();
    const [searchParams] = useSearchParams();
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const getUserFromStorage = () => {
        try {
            return JSON.parse(localStorage.getItem("user")) || null;
        } catch {
            return null;
        }
    };

    const user = getUserFromStorage();
    const userId = user?.userid;

    const queryDate = searchParams.get("date");
    const queryTime = searchParams.get("time");
    const queryGuests = searchParams.get("guests");

    const [restaurant, setRestaurant] = useState(null);
    const [restdocdetails, setRestdocdetails] = useState([]);
    const [restaurantImgs, setRestaurantImgs] = useState([]);
    const [dailyTiming, setDailyTiming] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const today = new Date().toISOString().split("T")[0];
    // const [selectedDate, setSelectedDate] = useState(today);
    // const [selectedGuests, setSelectedGuests] = useState(2);
    // const [selectedTime, setSelectedTime] = useState("");
    const [selectedDate, setSelectedDate] =
        useState(queryDate || today);

    const [selectedGuests, setSelectedGuests] =
        useState(queryGuests || 2);

    const [selectedTime, setSelectedTime] =
        useState(queryTime || "");
    const [showPreview, setShowPreview] = useState(false);
    const [showBookingPopup, setShowBookingPopup] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [timeSlotsFromAPI, setTimeSlotsFromAPI] = useState([]);
    const [bookingLoading, setBookingLoading] = useState(false);
    const [searchedTime, setSearchedTime] = useState("");

    const formatDateForAPI = (date) => {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const formatAPITime = (timeStr) => {
        const cleanTime = timeStr.split(".")[0];
        const [hours, minutes] = cleanTime.split(":");

        const h = parseInt(hours);
        const ampm = h >= 12 ? "PM" : "AM";
        const hour12 = h % 12 || 12;

        return {
            value: `${hours}:${minutes}`,
            label: `${hour12}:${minutes} ${ampm}`
        };
    };

    const normalizeTime = (time) => {
        return time.split(".")[0].slice(0, 5);
    };

    const overviewRef = useRef(null);
    const experienceRef = useRef(null);
    const photosRef = useRef(null);
    const menuRef = useRef(null);

    const scrollTo = (ref) => {
        ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const formatDate = (dateStr) => {
        const options = { day: "numeric", month: "long", year: "numeric" };
        return new Date(dateStr).toLocaleDateString("en-GB", options);
    };

    const formatTimeTo12Hr = (time) => {
        const [hours, minutes] = time.split(":");
        const h = parseInt(hours);
        const ampm = h >= 12 ? "PM" : "AM";
        const hour12 = h % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
    };

    useEffect(() => {
        const fetchRestaurant = async () => {
            try {
                setLoading(true);

                // const response = await axios.post(
                //     // "https://highwycombebites.com/api/Admin/getrestaurantmasterdata",
                //     "https://www.highwycombebites.com/api/booking/getDiningRestaurantDetails",
                //     {
                //         pkid: pkid.toString(),
                //         data: "string",
                //         reason: "string",
                //     }
                // );

                const response = await axios.post(
                    "https://www.highwycombebites.com/api/booking/getDiningRestaurantDetails",
                    {
                        pkid: pkid.toString(),
                        Date: formatDateForAPI(selectedDate),
                        Time: selectedTime || "",
                        Location: "",
                        TotalPerson: selectedGuests
                    }
                );

                if (response.data?.success === "1") {
                    setRestaurant(response.data.restaurantlist?.[0] || null);
                    setRestdocdetails(response.data.restdocdetails || []);
                    setRestaurantImgs(response.data.restaurantimgs || []);
                    setDailyTiming(response.data.dailytiming || []);
                    setTimeSlotsFromAPI(response.data.timeSlot || []);
                } else {
                    setError("Restaurant not found");
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (pkid) fetchRestaurant();
    }, [pkid]);

    const handleConfirmBooking = async () => {

        if (!userId) {
            setShowLoginPopup(true);
            return;
        }

        try {
            setBookingLoading(true);

            const payload = {
                restid: parseInt(restaurant.pkid),
                custid: parseInt(userId),
                offerid: 0,
                bookingtime: selectedTime,
                bookingdate: selectedDate,
                guestcapicity: parseInt(selectedGuests),
                occasion: "",
                specialrequest: "",
                ispaid: true,
                amount: 55,
                paymentstatus: "Pending",
                devicetype: "Web",
            };

            const response = await axios.post(
                "https://highwycombebites.com/api/booking/SaveDiningBooking",
                payload
            );

            if (response.data?.paymenturl) {
                window.location.href = response.data.paymenturl;
            } else {
                alert("Booking Saved");
                setBookingLoading(false);
            }

        } catch (error) {
            console.error(error);
            alert("Something went wrong");
            setBookingLoading(false);
        }
    };

    const bannerImg = restdocdetails.find(
        (d) => d.documentname === "BANNER IMAGE"
    )?.imagename;

    const logoImg = restdocdetails.find(
        (d) => d.documentname === "LOGO"
    )?.imagename;

    const isFutureTimeSlot = (slotTime) => {

        if (!selectedDate) return true;

        const todayDate = new Date();
        const selected = new Date(selectedDate);

        // ✅ If NOT today → allow all
        if (selected.toDateString() !== todayDate.toDateString()) {
            return true;
        }

        // ✅ Today → check time
        const cleanTime = slotTime.split(".")[0];
        const [hours, minutes] = cleanTime.split(":");

        const slotDate = new Date();
        slotDate.setHours(parseInt(hours), parseInt(minutes), 0);

        return slotDate > todayDate;
    };

    const getSmartSlots = () => {

        const activeSlots = timeSlotsFromAPI
            .filter(slot => slot.isActive)
            .filter(slot => isFutureTimeSlot(slot.time))
            .sort((a, b) =>
                normalizeTime(a.time).localeCompare(normalizeTime(b.time))
            );

        // ✅ No search → show first 5
        if (!searchedTime) {
            return activeSlots.slice(0, 5);
        }

        // convert searched time
        const search = searchedTime.slice(0, 5);

        // ✅ find nearest slot (NOT exact only)
        let closestIndex = 0;
        let minDiff = Infinity;

        activeSlots.forEach((slot, index) => {
            const slotTime = normalizeTime(slot.time);

            const diff =
                Math.abs(
                    new Date(`1970-01-01T${slotTime}:00`) -
                    new Date(`1970-01-01T${search}:00`)
                );

            if (diff < minDiff) {
                minDiff = diff;
                closestIndex = index;
            }
        });

        let start = closestIndex - 2;
        let end = closestIndex + 3;

        if (start < 0) {
            start = 0;
            end = 5;
        }

        if (end > activeSlots.length) {
            end = activeSlots.length;
            start = Math.max(0, end - 5);
        }

        return activeSlots.slice(start, end);
    };

    /* ================= STATES ================= */
    if (loading) return <div className="text-center py-5">Loading…</div>;
    if (error) return <div className="text-center py-5 text-danger">{error}</div>;
    if (!restaurant) return <div className="text-center py-5">No data found</div>;

    return (
        <>
            <Navbar />

            <div style={{ background: "#f8f8f8" }}>
                {/* ================= HERO ================= */}
                <div
                    className="hero-image"
                    style={{
                        backgroundImage: bannerImg
                            ? `url(https://highwycombebites.com/documents/${bannerImg})`
                            : "url('https://images.unsplash.com/photo-1541544741938-0af808871cc0')",
                    }}
                >
                    <button className="save-btn" >♡ Save this restaurant</button>
                    <p
                        className="more-btn"
                        onClick={() => {
                            setCurrentImageIndex(0);
                            setShowPreview(true);
                        }}
                    >
                        + more
                    </p>
                </div>

                <div className="restaurant-container">
                    {/* ================= LEFT CONTENT ================= */}
                    <div className="left-content">
                        <h1>{restaurant.name}</h1>
                        <p style={{ color: "#555", marginBottom: "20px" }}>
                            ⭐ {restaurant.hyginerating || "N/A"} · {restaurant.location}
                        </p>

                        {/* ================= TABS ================= */}
                        <div
                            style={{
                                display: "flex",
                                gap: "24px",
                                borderBottom: "1px solid #ddd",
                                marginBottom: "30px",
                                paddingBottom: "10px",
                                // position: "sticky",
                                top: "0",
                                background: "#f8f8f8",
                                zIndex: 10,
                            }}
                        >
                            <span onClick={() => scrollTo(overviewRef)} style={tabStyle}>
                                Overview
                            </span>
                            <span onClick={() => scrollTo(experienceRef)} style={tabStyle}>
                                Experiences
                            </span>
                            <span onClick={() => scrollTo(photosRef)} style={tabStyle}>
                                Photos
                            </span>
                            <span onClick={() => scrollTo(menuRef)} style={tabStyle}>
                                Menu
                            </span>
                        </div>

                        <section ref={overviewRef}>
                            <h2>About this restaurant</h2>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: restaurant.description || "",
                                }}
                            />
                        </section>

                        {/* ================= EXPERIENCES ================= */}
                        <section ref={experienceRef}>
                            <h2>Experiences</h2>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: restaurant.dininginstructions || "No experiences",
                                }}
                            />
                        </section>

                        {/* ================= PHOTOS ================= */}
                        <section ref={photosRef}>
                            <h2>Photos</h2>
                            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                {restaurantImgs.map((img) => (
                                    <img
                                        key={img.pkid}
                                        src={`https://highwycombebites.com/documents/${img.imagename}`}
                                        alt="restaurant"
                                        style={{
                                            width: "150px",
                                            height: "100px",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                        }}
                                    />
                                ))}
                            </div>
                        </section>

                        <section ref={menuRef}>
                            <h2>Menu</h2>
                            <p>Menu will be available soon.</p>
                        </section>

                        <section>
                            <h2>Opening Hours</h2>
                            <ul>
                                {dailyTiming.map((d) => (
                                    <li key={d.day}>
                                        <strong>{d.day}:</strong>{" "}
                                        {d.closed === "1"
                                            ? "Closed"
                                            : `${d.starttime} - ${d.endtime}`}
                                    </li>
                                ))}
                            </ul>
                        </section>
                    </div>

                    <div className="right-content">
                        <div
                            style={{
                                background: "#fff",
                                padding: "20px",
                                borderRadius: "12px",
                                boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                            }}
                        >
                            <h3 style={{ marginBottom: "15px" }}>Make a booking</h3>

                            {/* DATE - FULL WIDTH */}
                            <input
                                type="date"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                                style={inputStyle}
                                min={today}
                            />

                            {/* PEOPLE + TIME SAME LINE */}
                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    marginTop: "10px"
                                }}
                            >

                                {/* PEOPLE */}
                                <select
                                    value={selectedGuests}
                                    onChange={(e) => setSelectedGuests(e.target.value)}
                                    style={{ ...inputStyle, flex: 1 }}
                                >
                                    {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
                                        <option key={num} value={num}>
                                            {num} {num === 1 ? "Person" : "People"}
                                        </option>
                                    ))}
                                </select>

                                {/* TIME SEARCH */}
                                <input
                                    type="time"
                                    value={searchedTime}
                                    onChange={(e) => setSearchedTime(e.target.value)}
                                    style={{ ...inputStyle, flex: 1 }}
                                />

                            </div>

                            <div style={{ marginTop: "15px" }}>
                                <p style={{ fontWeight: 500, marginBottom: "8px" }}>
                                    Select time
                                </p>

                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "8px",
                                    }}
                                >
                                    {getSmartSlots().map((slot) => {

                                        const formatted = formatAPITime(slot.time);
                                        const isSelected = selectedTime === formatted.value;

                                        return (
                                            <button
                                                key={slot.pkid}
                                                onClick={() => setSelectedTime(formatted.value)}
                                                style={{
                                                    padding: "6px 12px",
                                                    borderRadius: "6px",
                                                    border: isSelected
                                                        ? "1px solid #009fe4"
                                                        : "1px solid #ddd",
                                                    background: isSelected ? "#009fe4" : "#fff",
                                                    color: isSelected ? "#fff" : "#333"
                                                }}
                                            >
                                                {formatted.label}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>

                            <p style={{ marginTop: "15px", fontSize: "14px", color: "#555" }}>
                                Minimum order: £{restaurant.diningcharge}
                            </p>

                            <button
                                disabled={!selectedDate || !selectedTime}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginTop: "10px",
                                    borderRadius: "6px",
                                    border: "none",
                                    background:
                                        selectedDate && selectedTime ? "#009fe4" : "#ccc",
                                    color: "#fff",
                                    cursor:
                                        selectedDate && selectedTime ? "pointer" : "not-allowed",
                                }}
                                // onClick={() => {
                                //     setShowBookingPopup(true);
                                // }}
                                onClick={() => {

                                    if (!userId) {
                                        setShowLoginPopup(true);
                                        return;
                                    }

                                    setShowBookingPopup(true);
                                }}
                            >
                                Book Now
                            </button>
                        </div>
                    </div>
                </div>
            </div >

            {showLoginPopup && (
                <div className="booking-overlay">
                    <div className="booking-modal">

                        <h3 style={{ marginBottom: "15px" }}>
                            🔒 You are not logged in
                        </h3>

                        <p style={{ textAlign: "center", marginBottom: "20px" }}>
                            Please login to continue your booking.
                        </p>

                        <div className="booking-actions">

                            <button
                                className="confirm-btn"
                                onClick={() => {
                                    window.location.href = "/login";
                                }}
                            >
                                Login Now
                            </button>

                            <button
                                className="cancel-btn"
                                onClick={() => setShowLoginPopup(false)}
                            >
                                Cancel
                            </button>

                        </div>
                    </div>
                </div>
            )}

            <Footer />
            {
                showPreview && (
                    <div className="image-preview-overlay">
                        <span
                            className="close-preview"
                            onClick={() => setShowPreview(false)}
                        >
                            ✕
                        </span>

                        <button
                            className="nav-btn left"
                            onClick={() =>
                                setCurrentImageIndex((prev) =>
                                    prev === 0 ? restaurantImgs.length - 1 : prev - 1
                                )
                            }
                        >
                            ‹
                        </button>

                        <img
                            src={`https://highwycombebites.com/documents/${restaurantImgs[currentImageIndex]?.imagename}`}
                            alt="Preview"
                            className="preview-image"
                        />

                        <button
                            className="nav-btn right"
                            onClick={() =>
                                setCurrentImageIndex((prev) =>
                                    prev === restaurantImgs.length - 1 ? 0 : prev + 1
                                )
                            }
                        >
                            ›
                        </button>

                        <div className="image-count">
                            {currentImageIndex + 1} of {restaurantImgs.length}
                        </div>
                    </div>
                )
            }

            {
                showBookingPopup && (
                    <div className="booking-overlay">
                        <div className="booking-modal">

                            <span
                                className="booking-close"
                                onClick={() => setShowBookingPopup(false)}
                            >
                                ✕
                            </span>

                            {logoImg && (
                                <div className="booking-logo">
                                    <img
                                        src={`https://highwycombebites.com/documents/${logoImg}`}
                                        alt="Restaurant Logo"
                                    />
                                </div>
                            )}

                            <h3 className="booking-title">Confirm Your Reservation</h3>

                            <div className="booking-card">

                                <div className="booking-row">
                                    <span>🍽</span>
                                    <div>
                                        <strong>{restaurant.name}</strong>
                                        <p>{restaurant.location}</p>
                                    </div>
                                </div>

                                <div className="booking-divider" />

                                <div className="booking-row">
                                    <span>📅</span>
                                    <p>{formatDate(selectedDate)}</p>
                                </div>

                                <div className="booking-row">
                                    <span>⏰</span>
                                    <p>{formatTimeTo12Hr(selectedTime)}</p>
                                </div>

                                <div className="booking-row">
                                    <span>👥</span>
                                    <p>{selectedGuests} {selectedGuests === 1 ? "Guest" : "Guests"}</p>
                                </div>

                            </div>

                            <div className="booking-actions">
                                <button
                                    className="confirm-btn"
                                    onClick={handleConfirmBooking}
                                    disabled={bookingLoading}
                                >
                                    {bookingLoading ? (
                                        <>
                                            <span className="btn-spinner"></span>
                                            Processing...
                                        </>
                                    ) : (
                                        "Confirm & Pay"
                                    )}
                                </button>

                                <button
                                    className="cancel-btn"
                                    onClick={() => setShowBookingPopup(false)}
                                >
                                    Edit
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

        </>
    );
};

export default BookTablePage;

/* ================= STYLES ================= */
const tabStyle = {
    cursor: "pointer",
    fontWeight: 500,
    color: "#009fe4",
};

const inputStyle = {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #e0e0e0",
    fontSize: "14px",
    outline: "none",
    background: "#fff",
};

